<template>
  <li class="list-card-item">
    <div class="card vcard add-card-loading list-card-item" tabindex="-1">
      <div class="card-img-top mb-2">
        <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        <span class="sr-only">{{ i18n.loading }}</span>
      </div>
      <span class="title-level level-3 mx-2 card-title mb-1 mt-1 card-loading-line"></span>
      <div class="card-body">
        <p class="card-text mx-2 row">
          <span class="card-loading-line col-10">
            <br />
          </span>
          <span class="card-loading-line col-7">
            <br />
          </span>
          <span class="card-loading-line col-8">
            <br />
          </span>
          <span class="card-loading-line col-10">
            <br />
          </span>
        </p>
      </div>
    </div>
  </li>
</template>

<style lang="less">
@import 'card.less';
</style>

<script>
export default {
  data: function() {
    return {
      i18n: {
        results: this.$t(`loading`),
      },
    };
  },
};
</script>
